export enum EventScope {
  THIS_FRAME,
  ALL_FRAMES,
  EXPOSED,
}
